import { Area } from 'editor/src/store/design/operation/getNewElementDisplay';
import { MediaElement, MediaLine, Spread } from 'editor/src/store/design/types';

import { SheetRect } from 'editor/src/util/gangSheet/findFreeSpot';
import getPointPositionRotatedOnPoint from 'editor/src/util/getPointPositionRotatedOnPoint';

// The axis-aligned box an element covers on the canvas, mm. Elements rotate around their
// top-left corner, so it is the box around the four rotated corners.
export function getElementFootprint(element: Exclude<MediaElement, MediaLine>): {
  left: number;
  top: number;
  width: number;
  height: number;
} {
  const { x, y, width, height, r = 0 } = element;
  const corners = [
    [x, y],
    getPointPositionRotatedOnPoint(x + width, y, x, y, r),
    getPointPositionRotatedOnPoint(x + width, y + height, x, y, r),
    getPointPositionRotatedOnPoint(x, y + height, x, y, r),
  ];
  const xs = corners.map(([cx]) => cx);
  const ys = corners.map(([, cy]) => cy);
  const left = Math.min(...xs);
  const top = Math.min(...ys);
  return { left, top, width: Math.max(...xs) - left, height: Math.max(...ys) - top };
}

// The footprint of every visible element on the sheet, relative to the sheet's top-left
// corner. `excludeUuids` leaves out elements the caller is about to place itself.
function getSheetArtworkRects(spread: Spread | undefined, area: Area, excludeUuids?: Set<number>): SheetRect[] {
  const rects: SheetRect[] = [];
  spread?.pages[0]?.groups.media?.forEach((element) => {
    if (element.type === 'line' || element.hidden || excludeUuids?.has(element.uuid)) {
      return;
    }
    const footprint = getElementFootprint(element);
    rects.push({
      xMm: footprint.left - area.left,
      yMm: footprint.top - area.top,
      widthMm: footprint.width,
      heightMm: footprint.height,
    });
  });
  return rects;
}

export default getSheetArtworkRects;
